import { UAParser } from 'ua-parser-js';
import { v4 as uuidv4 } from 'uuid';

let SPEED_TEST_API_BASE_URL = 'https://hsi-speed-test-api.stage.clear.link';
if (window.location.host === 'www.highspeedinternet.com') {
    SPEED_TEST_API_BASE_URL = 'https://hsi-speed-test-api.clear.link';
}
const CLIENT_ID = 'Hsi-123456';

const { browser, os } = UAParser(navigator.userAgent);

const getOrCreateGuid = () => {
    const key = 'hsi-speedtest-guid';
    const guid = localStorage.getItem(key) ?? uuidv4();
    localStorage.setItem(key, guid);

    return guid;
};

export const deviceRegistration = () => {
    $.ajax({
        url: `${SPEED_TEST_API_BASE_URL}/hsi/deviceregistration`,
        data: JSON.stringify({
            model: navigator.userAgent,
            platform: os.name,
            osVersion: os.version,
            guid: getOrCreateGuid(),
            appVersion: '1.0.0',
            brand: browser.name,
            isWeb: true,
            clientId: CLIENT_ID,
        }),
        type: 'POST',
        contentType: 'application/json',
        headers: {
            Accept: '*/*',
        },
        error: (err) => {
            console.log(err);
        },
    });
};

export const speedTestStart = ({ onSuccess }) => {
    $.ajax({
        url: `${SPEED_TEST_API_BASE_URL}/hsi/speedteststart`,
        data: JSON.stringify({
            guid: getOrCreateGuid(),
            isWeb: true,
            clientId: CLIENT_ID,
        }),
        type: 'POST',
        contentType: 'application/json',
        headers: {
            Accept: '*/*',
        },
        success: (res) => {
            if (res?.success) {
                onSuccess(res.data);
            }
        },
        error: (err) => {
            console.log(err);
        },
    });
};

const average = (array) => array.reduce((a, b) => a + b) / array.length;

export const speedTestComplete = ({
    speedTestId,
    maxDownloadSpeed,
    maxUploadSpeed,
    finalDownloadSpeed,
    finalUploadSpeed,
    downElapsed,
    upElapsed,
    downloadData,
    uploadData,
    ipAddress,
    provider,
    server,
    serverCity,
    serverCountry,
    connectionType,
    latency,
    jitter,
    packetLoss,
}) => {
    if (speedTestId) {
        const averageDownloadSpeed = average(downloadData);
        const averageUploadSpeed = average(uploadData);

        $.ajax({
            url: `${SPEED_TEST_API_BASE_URL}/hsi/speedtestcomplete`,
            data: JSON.stringify({
                speedTestId,
                guid: getOrCreateGuid(),
                maxDownloadSpeed,
                maxUploadSpeed,
                finalDownloadSpeed,
                finalUploadSpeed,
                averageDownloadSpeed,
                averageUploadSpeed,
                downElapsed,
                upElapsed,
                downloadData,
                uploadData,
                ipAddress,
                provider,
                server,
                serverCity,
                serverCountry,
                connectionType,
                latency,
                jitter,
                packetLoss,
                clientId: CLIENT_ID,
                platform: navigator.userAgent,
                isWeb: true,
            }),
            type: 'POST',
            contentType: 'application/json',
            headers: {
                Accept: '*/*',
            },
            error: (err) => {
                console.log(err);
            },
        });
    }
};
